import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

export default class FMPTextField extends Component {
	render () {
		const { name, controller, contained, helpText, multiline, attr, index, md, disabled } = this.props;
		const label = (this.props.label) ? this.props.label : _.capitalize(name);

		const { formFieldError = {} } = controller.state || {};

		let value, onChange, error;
		if (attr && _.isNumber(index)) {
			value = controller.state[name][index][attr] || '';
			error = _.get(formFieldError, [name, index, attr]);
			onChange = event => controller.onChange(event, name, index, attr);
		} else if (_.isNumber(index)) {
			value = controller.state[name][index] || '';
			error = _.get(formFieldError, [name, index]);
			onChange = event => controller.onChange(event, name, index);
		} else {
			value = controller.state[name] || '';
			error = _.get(formFieldError, [name]);
			onChange = event => controller.onChange(event, name);
		}

		const content = (
			<Grid item xs={12} md={md}>
				<FormControl fullWidth={true} error={!!error} disabled={disabled}>

					{!multiline &&
					<TextField
						error={!!error}
						disabled={disabled}
						value={value}
						onChange={onChange}
						label={label}
						fullWidth
					/>}

					{multiline &&
					<TextField
						error={!!error}
						disabled={disabled}
						value={value}
						onChange={onChange}
						label={label}
						multiline
						rows={multiline}
						fullWidth
					/>}

					{error && <FormHelperText>{error}</FormHelperText>}
					{(helpText && !error) && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		);

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FMPTextField.propTypes = {
	name: PropTypes.string.isRequired,
	controller: PropTypes.object.isRequired,
	label : PropTypes.string,
	helpText : PropTypes.string,
	contained : PropTypes.bool,
	multiline: PropTypes.number,
	attr : PropTypes.string,
	index : PropTypes.number,
	md : PropTypes.number,
	disabled : PropTypes.bool,
};

FMPTextField.defaultProps = {
	contained : true,
	md : 6,
};